import InputCode, {
  ICodeItem
} from '@/components/molecules/InputCode/InputCode.vue'

export { InputCode, ICodeItem }
